/**
 * Tiny status pills used by Logs and Audit pages.
 */

const LEVEL_TONES = {
  error: 'bg-rose-soft text-rose-700 border-rose-200',
  warn:  'bg-warning-soft text-warning border-warning/30',
  info:  'bg-accent-soft text-accent border-accent/20',
  debug: 'bg-canvas text-mist border-line',
};

const LEVEL_ICONS = {
  error: 'fa-circle-exclamation',
  warn:  'fa-triangle-exclamation',
  info:  'fa-circle-info',
  debug: 'fa-bug',
};

export function LevelBadge({ level }) {
  const tone = LEVEL_TONES[level] || LEVEL_TONES.info;
  const icon = LEVEL_ICONS[level] || LEVEL_ICONS.info;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${tone}`}>
      <i className={`fa-solid ${icon} text-[9px]`} aria-hidden="true" />
      {level || 'info'}
    </span>
  );
}

const OUTCOME_TONES = {
  success: 'bg-success-soft text-success border-success/30',
  failure: 'bg-rose-soft text-rose-700 border-rose-200',
  denied:  'bg-warning-soft text-warning border-warning/30',
};

const OUTCOME_ICONS = {
  success: 'fa-circle-check',
  failure: 'fa-circle-xmark',
  denied:  'fa-shield-halved',
};

export function OutcomeBadge({ outcome }) {
  const tone = OUTCOME_TONES[outcome] || 'bg-canvas text-mist border-line';
  const icon = OUTCOME_ICONS[outcome] || 'fa-circle-question';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${tone}`}>
      <i className={`fa-solid ${icon} text-[9px]`} aria-hidden="true" />
      {outcome}
    </span>
  );
}

export function HttpStatusBadge({ status }) {
  let tone = 'bg-canvas text-mist border-line';
  if (status >= 200 && status < 300) tone = 'bg-success-soft text-success border-success/30';
  else if (status >= 300 && status < 400) tone = 'bg-accent-soft text-accent border-accent/20';
  else if (status >= 400 && status < 500) tone = 'bg-warning-soft text-warning border-warning/30';
  else if (status >= 500) tone = 'bg-rose-soft text-rose-700 border-rose-200';
  return (
    <span className={`inline-flex items-center justify-center rounded border px-1.5 py-0.5 text-[10px] font-mono font-semibold ${tone}`}>
      {status}
    </span>
  );
}

export function MethodBadge({ method }) {
  const tones = {
    GET:    'border-line bg-canvas text-ink',
    POST:   'border-success/30 bg-success-soft text-success',
    PATCH:  'border-warning/30 bg-warning-soft text-warning',
    PUT:    'border-warning/30 bg-warning-soft text-warning',
    DELETE: 'border-rose-200 bg-rose-soft text-rose-700',
  };
  const tone = tones[method] || tones.GET;
  return (
    <span className={`inline-flex items-center justify-center rounded border px-1.5 py-0.5 text-[10px] font-mono font-semibold ${tone}`}>
      {method}
    </span>
  );
}
